import { useCallback, useState } from "react";

import client from "../../client";
import { handleToast } from "../../../utils/functions";
import handleApiError from "../../../hooks/handleApiError";

export default function useEditAcademicSession() {
  const [loading, setLoading] = useState(false);

  const request = useCallback(async (id, payload) => {
    try {
      setLoading(true);

      const res = await client.put(
        `/calendar/academic-sessions/${id}`,
        payload
      );

      handleToast(res.data?.message);
      setLoading(false);

      return true;
    } catch (error) {
      setLoading(false);
      handleApiError(error);
    }
  }, []);

  return { loading, request };
}
